<template>
  <popup-layout title="비밀번호 변경" :is-show="isShow" width="95vw" max-width="550">
    <template v-slot:content>
     <v-row class="mx-2">
       <div class="change-password-notice">
         <span>* 숫자 및 영문 + 특수문자 1개 이상 포함 10자리 이상</span>
         <span>(특수문자는 ! ~ * 만 사용가능)</span>
       </div>
       <field-input title="변경할 비밀번호" cols="1">
         <v-text-field
           v-model="newPW"
           :type="showNewPW ? 'text' : 'password'"
           :append-icon="showNewPW ? 'mdi-eye' : 'mdi-eye-off'"
           @click:append="showNewPW = !showNewPW"
           placeholder="변경할 비밀번호를 입력해주세요"
           outlined hide-details dense
           background-color="white"
         />
       </field-input>
       <field-input title="비밀번호 확인" cols="1">
         <v-text-field
           v-model="checkNewPW"
           :type="showCheckNewPW ? 'text' : 'password'"
           :append-icon="showCheckNewPW ? 'mdi-eye' : 'mdi-eye-off'"
           @click:append="showCheckNewPW = !showCheckNewPW"
           placeholder="비밀번호를 한번 더 입력해주세요"
           :error="notSamePW"
           outlined hide-details dense
           background-color="white"
         />
       </field-input>
     </v-row>
    </template>
    <template v-slot:button>
      <div class="buttons-layout">
        <v-btn class="button save" outlined @click="isChangePW">변경</v-btn>
        <v-btn class="button delete" outlined @click="closePopup">취소</v-btn>
      </div>
    </template>
  </popup-layout>
</template>
<script>

import {axiosInstance} from "@/util/AxiosModule";
import PopupLayout from "@/common/layout/PopupLayout.vue";
import FieldInput from "@/common/components/input/FieldInput.vue";
import {mapGetters} from "vuex";

export default {
  name: "ChangePW",
  props: ["isShow", "userData"],
  components: {FieldInput, PopupLayout},
  data() {
    return {
      newPW: "",
      checkNewPW: "",
      showNewPW: false,
      showCheckNewPW: false
    }
  },
  computed: {
    ...mapGetters("login", {memberId: "memberId"}),
    notSamePW() {
      return (this.checkNewPW !== '') && (this.newPW !== this.checkNewPW)
    }
  },
  methods: {
    isChangePW() {
      const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!~*])[A-Za-z\d!~*]{10,}$/;
      if (this.notSamePW) {
        this.showAlert({message: "변경할 비밀번호와 비밀번호 확인이 일치하지 않습니다"});
        return false;
      }
      if (!passwordRegex.test(this.checkNewPW)) {
        this.showAlert({message: "비밀번호 조건에 맞춰 다시 입력해주세요"});
        return false;
      }

      this.showConfirm({
        message: "비밀번호를 변경하시겠습니까?",
        successCallback: () => {
          this.changePW();
        },
        failCallback: () => {
          return false;
        }
      })
    },
    async changePW() {
      try {
        await axiosInstance.patch("/private/member/password-change", {}, {
          params: {
            memberId: this.memberId,
            newPassword: this.checkNewPW
          }
        }).then(() => {
          this.showAlert({
            message: "비밀번호 변경이 완료되었습니다",
            successCallback: () => {
              this.$emit("refresh");
              this.closePopup();
            }
          })
        })
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
    },
    setDefaultData() {
      this.newPW = "";
      this.checkNewPW = "";
    },
    closePopup() {
      this.setDefaultData();
      this.$emit("close");
    }
  }
}
</script>

<style lang="scss" scoped>
.change-password-notice {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.buttons-layout {
  width: 100%;
  margin: 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>